<template>
  <div class="tests">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h2 class="pb-4">Доступні тести</h2>
        </div>
        <div class="col-12">
          <b-overlay :show="isLoading" spinner-variant="warning">
            <b-card class="mb-3 test" v-for="t in tests" :key="t.id">
              <h3 class="test__title">
                {{ t.name }}
              </h3>
              <p class="description" v-if="t.description">
                {{ t.description }}
              </p>
              <hr />
              <div
                class="d-flex meta align-items-center justify-content-between"
              >
                <div>
                  <div class="item">Запитань: {{ t.questions.length }}</div>
                </div>
                <div class="controls text-end">
                  <b-button
                    variant="link d-none"
                    style="margin-right: 20px"
                    size="md"
                    >Мої результати</b-button
                  >
                  <b-button
                    :to="{
                      name: 'candidate-test-single',
                      params: { id: t.id },
                    }"
                    variant="primary"
                    size="md"
                    >Пройти тест
                  </b-button>
                </div>
              </div>
            </b-card>
          </b-overlay>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      tests: [],
    };
  },
  methods: {
    async getAvailableTests() {
      this.isLoading = true;
      const args = {
        collectionName: "tests",
      };
      let result = await this.$db.getCollection(args);
      this.tests = result.docs;
      this.isLoading = false;
    },
  },
  mounted() {
    this.getAvailableTests();
  },
};
</script>

<style lang="scss" scoped>
.tests {
  padding-top: 60px;
  .test {
    &__title {
      //   font-size: 26px;
    }
  }
  .description {
    color: #666;
    line-height: 1.4;
    font-size: 14px;
  }
}
</style>
